import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs, InputNumber } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ICourseDefinition, listCourseDefinitions, createCourseDefinition, updateCourseDefinition, deleteCourseDefinition, pageCourseDefinitions } from '../../service/api/courseDefinition';
import moment from 'moment';
import { pageCardDefinitions, updateCardDefinition, createCardDefinition, ICardDefinition, enableCardDefinition } from '../../service/api/cardDefinition';
import { FormInstance } from 'antd/lib/form/Form';
import './css.less';
const { confirm } = Modal;
const { Option } = Select;

interface ICardDefinitionListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const CardDefinitionList: React.FC<ICardDefinitionListProps> = ({
  visible,
  setVisible,
}) => {
  const [cardDefinitions, setCardDefinitions] = useState<ICardDefinition[]>();
  const [cardDefinitionDetail, setCardDefinitionDetail] = useState<ICardDefinition>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const formRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '课程信息',
      dataIndex: 'courseMessage',
      key: 'courseMessage',
    },
    // {
    //   title: '课程包类型',
    //   dataIndex: 'type',
    //   key: 'type',
    //   render: (text: any, record: any) => {
    //     switch (record.type) {
    //       case 1:
    //         return '课时卡';
    //       case 2:
    //         return '时间卡';
    //       case 3:
    //         return '金额卡';
    //       default:
    //         break
    //     }
    //   }
    // },
    // {
    //   title: '课程包数值',
    //   dataIndex: 'value',
    //   key: 'value',
    // },
    {
      title: '课程包有效时间（天）',
      dataIndex: 'effectiveDay',
      key: 'effectiveDay',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '原价',
      dataIndex: 'originalPrice',
      key: 'originalPrice',
      render: (text: any, record: any) => {
        return <div style={{ textDecoration: 'line-through' }}>{record.originalPrice}</div>
      }
    },
    {
      title: '售卖价格',
      dataIndex: 'sellPrice',
      key: 'sellPrice',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <span style={{ color: 'green' }}>使用中</span>
        } else {
          return <span style={{ color: 'grey' }}>已停用</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setCardDefinitionDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>停用 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setCardDefinitionDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>启用 </a>
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (cardDefinitionDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(cardDefinitionDetail);
      }, 100);
    }
  }, [cardDefinitionDetail]);

  const loadData = () => {
    pageCardDefinitions(pageNum, pageSize).then((info: any) => {
      setCardDefinitions(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (cardDefinitionDetail) {
      updateCardDefinition({
        ...values,
        id: cardDefinitionDetail.id
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createCardDefinition(values).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onEnable = (e: any, item: ICardDefinition) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: item.enable ? '确定要停用该课程包吗？停用后无法被选到' : '确定要启用该课程包吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        enableCardDefinition(item.id, !item.enable).then((info: any) => {
          // console.log("info:" + JSON.stringify(info));
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setCardDefinitionDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };

  // 下拉框值
  const options = courseDefinitions?.map((courseDefinition) =>
    <Option key={courseDefinition.id} value={courseDefinition.id}>{courseDefinition.name}</Option>);

  return (
    <Card bordered={false}>
      <Table dataSource={cardDefinitions} columns={columns} pagination={false} 
      rowClassName={(record, index) => {
        if (record.enable) {
          return 'cardDefinitionValid';
        } else {
          return 'cardDefinitionInvalid';
        }
      }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={cardDefinitionDetail ? "编辑课程包" : "新增课程包"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="effectiveDay"
                label="课程包有效天数"
                rules={[{ required: true, message: '请输入课程包有效天数' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sellPrice"
                label="售卖价格"
                rules={[{ required: true, message: '请输入售卖价格' }]}
              >
                <InputNumber placeholder="请输入售卖价格" step="0.01"/>
              </Form.Item>
            </Col>
          </Row>
          <Form.List name="courseDefinitionRefs">
            {(fields, { add, remove }) => (
              <>
                <div style={{ paddingBottom: '10px' }}>包含课程信息</div>
                {fields.map(({ name, fieldKey, ...restField }) => (
                  <Row gutter={16}>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'value']}
                        fieldKey={[fieldKey, 'value']}
                        rules={[{ required: true, message: '请输入课程数' }]}
                      >
                        <Input placeholder="请输入课程数" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'courseDefinitionId']}
                        fieldKey={[fieldKey, 'courseDefinitionId']}
                        rules={[{ required: true, message: '请选择课程' }]}
                      >
                        <Select placeholder="请选择课程"  >
                          {options}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ paddingTop: '8px' }} />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    添加课程信息
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default CardDefinitionList;
